<template>
  <div class="subscriptions">
    <md-tabs md-alignment="centered">
      <md-tab v-for="season, i in $store.state.receivedData.seasons.list" v-on:click="$store.state.activeSeasonID = season.id;" :md-label="`Sezona ${season.title}`"/>
    </md-tabs>
    <md-table v-model="$store.state.receivedData.subscriptions.list" v-if="$store.state.receivedData.subscriptions.list.length > 0" md-sort="id" md-sort-order="asc" class="subscriptions-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Pretplate</h1>
        </div>
      </md-table-toolbar>

      <md-table-row slot="md-table-row" slot-scope="{item}" md-selectable="single" md-auto-select>
        <md-table-cell md-label="Naziv" md-sort-by="title_hr">{{ item.title_hr }} <strong>{{ item.subscription_number }}</strong></md-table-cell>
        <md-table-cell class="tc" md-label="Slobodno/Prodano">{{ currentSeasonData(item).available }}/{{ currentSeasonData(item).sold }}</md-table-cell>
        <md-table-cell class="tc" md-label="Rezervirano">{{ currentSeasonData(item).reservation }}</md-table-cell>
        <md-table-cell class="small-cell" md-label="Dvorana">
          <md-button class="md-raised md-primary md-dense" v-if="hasUrl(item)" v-on:click="showTheatre(item); $store.dispatch('setActiveTab', 'subscriptionTheatre')">
            Prikaži
          </md-button>
          <md-button class="md-raised md-accent md-dense" v-else-if="$store.state.schema['subscription-bundle'].create" v-on:click="openCreateSubscriptionDialog(item)" >
            Kreiraj
          </md-button>
        </md-table-cell>
        <md-table-cell class="actions-cell" md-label="Akcije">
          <md-button class="md-icon-button md-accent" :disabled="!hasUrl(item)" v-on:click="$store.state.dialogs.deleteSubscription = true; $store.state.selectedObject = JSON.parse(JSON.stringify(item))" v-if="$store.state.schema['subscription-bundle'].update">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" :disabled="!hasUrl(item)" title="Izmjeni u pretplati" v-on:click="openUpdateDialog(item)" v-if="$store.state.schema['subscription-bundle'].update">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog :md-active.sync="$store.state.dialogs.subscriptionMain" v-on:md-closed="closeDialogs" :class="`theatre-dialog md-scrollbar ${getDialogClass}`">
      <md-toolbar md-elevation="0">
        <md-button class="md-icon-button md-accent md-raised" v-on:click="closeDialogs">
          <md-icon>close</md-icon>
        </md-button>
        <h3 class="md-title">{{ getDialogTitle }}</h3>
        <div class="md-toolbar-section-end">
          <!--<md-button class="md-raised md-accent md-dense" v-on:click="toggleAllSeats('select')">
            Označi sve
          </md-button>
          <md-button class="md-raised md-accent md-dense" v-on:click="toggleAllSeats('unselect')">
            Odznači sve
          </md-button>-->
          <md-button class="md-raised md-primary md-dense" v-if="$store.state.dialogs.updateSubscription" v-on:click="showTheatre($store.state.selectedObject); $store.dispatch('setActiveTab', 'subscriptionTheatre'); closeDialogs();">
            Prikaži
          </md-button>
        </div>
      </md-toolbar>
      <div class="theatre-container theatre-container-admin">
        <AdminTheatre/>
        <div class="selected-tickets selected-seats" v-if="$store.state.dialogs.createSubscription">
          <md-card>
            <SelectedSeats v-if="getSelectedSeats.length > 0"/>
            <md-card-actions>
              <md-list-item>
                <span>Odabrano sjedala: {{ getSelectedSeats.length }}</span>
                <md-button class="md-raised md-accent md-dense" v-on:click="createSubscription">
                  Kreiraj
                </md-button>
              </md-list-item>
            </md-card-actions>
          </md-card>
        </div>
        <div class="selected-tickets selected-seats" v-else>
          <md-card class="edit-subscription-card">
            <md-datepicker @click.native="clearDate($event, 'valid_from')" v-model="$store.state.theatre.valid_from" md-immediately>
              <label>Početak pretplate</label>
              <span class="edit-subscription-error md-error" v-if="$store.state.theatre.valid_from === null">Ovo polje je obavezno</span>
            </md-datepicker>
            <md-datepicker @click.native="clearDate($event, 'valid_until')" v-model="$store.state.theatre.valid_until" md-immediately>
              <label>Kraj pretplate</label>
              <span class="edit-subscription-error md-error" v-if="$store.state.theatre.valid_until === null">Ovo polje je obavezno</span>
            </md-datepicker>
            <md-field>
              <label>Organizacijska jedinica</label>
              <md-input required type="text" v-model="$store.state.theatre.organization_unit"/>
              <span class="edit-subscription-error md-error" v-if="$store.state.theatre.organization_unit === ''">Ovo polje je obavezno</span>
              <span class="edit-subscription-error md-error" v-if="$store.state.theatre.organization_unit && $store.state.theatre.organization_unit.length > 6">Ovo polje može imati maksimalno 6 karaktera</span>
            </md-field>
            <md-field>
              <label>Mjesto troška</label>
              <md-input required type="text" v-model="$store.state.theatre.cost_center"/>
              <span class="edit-subscription-error md-error" v-if="$store.state.theatre.cost_center === ''">Ovo polje je obavezno</span>
              <span class="edit-subscription-error md-error" v-if="$store.state.theatre.cost_center && $store.state.theatre.cost_center.length > 8">Ovo polje može imati maksimalno 8 karaktera</span>
            </md-field>
            <md-card-actions>
              <md-list-item>
                <md-button class="md-raised md-accent md-dense" v-on:click="editSubscriptionInfo">
                  Spremi
                </md-button>
              </md-list-item>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </md-dialog>

    <md-dialog-confirm :md-active.sync="$store.state.dialogs.deleteSubscription"
                md-title="Brisanje pretplate"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSubscription"
                >
    </md-dialog-confirm>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import axios from 'axios'

export default {
  name: 'Subscriptions',

  data(){
    return{
      toggleStatus: 'select',
      dateVisible: true
    }
  },

  computed: {
    ...mapGetters([
      'getSelectedSeats',
    ]),

    getDialogClass(){
      if(this.$store.state.dialogs.createSubscription) return 'create-subscription'
      return 'edit-subscription'
    },

    getDialogTitle(){
      if(this.$store.state.dialogs.createSubscription) return 'Odaberite mjesta koja nisu u pretplati'
      return 'Izmjenite mjesta u pretplati'
    },
  },

  methods: {
    showTheatre(subscription){
      this.$store.state.selectedObject = subscription;
      this.$store.dispatch('getTheatre', {url: this.$store.getters.getSeasonData.url});
      this.$store.dispatch('getPricelists', {id: this.$store.getters.getSeasonData.id});
      subscription.seasons.forEach((season) =>{
        if(season.season_id == this.$store.state.activeSeasonID){
        }
      })
    },

    clearDate(e, key){
      if(e.target.tagName === 'svg' || e.target.classList.contains('md-ripple')){
        this.$store.state.theatre[key] = null;
      }
    },

    currentSeasonData(item){
      let currentSeason = {};
      item.seasons.forEach((season) =>{
        if(season.season_id == this.$store.state.activeSeasonID) currentSeason = season;
      })
      return currentSeason
    },

    editSubscriptionInfo(){
      let context = {
        valid_from: this.$store.state.theatre.valid_from,
        valid_until: this.$store.state.theatre.valid_until,
        cost_center: this.$store.state.theatre.cost_center,
        organization_unit: this.$store.state.theatre.organization_unit,
      }
      this.$store.dispatch('editSubscriptionDetails', context);
    },

    /*toggleAllSeats(type){
      let status = type == 'select' ? 'available' : 'unavailable';
      this.$store.state.theatreLoaded = false;
      this.$store.dispatch('toggleAllSeats', type);
      let context = {
        'season': this.$store.state.activeSeasonID,
        'subscription': this.$store.state.selectedObject.id,
        'seat_updates':{
          'status': status,
          'seats': this.$store.getters.getSeatWithRow,
        },
        'state_time': this.$store.state.theatre.state_time
      }

      this.$store.dispatch('updateSubscription', {context});
    },*/

    hasUrl(subscription){
      let hasUrl = false;
      subscription.seasons.forEach((season) =>{
        if(season.season_id == this.$store.state.activeSeasonID && season.url !== undefined){
          hasUrl = true;
        }
      })

      return hasUrl;
    },

    openCreateSubscriptionDialog(subscription){
      let rowKey, seatKey = null;
      let index = 0;

      this.$store.state.dialogs.createSubscription = true;
      this.$store.state.dialogs.subscriptionMain = true;
      this.$store.state.selectedObject = JSON.parse(JSON.stringify(subscription));
      this.$store.state.selectedSeats = [];
      for(rowKey in this.$store.state.theatre.rows){
        index++;
        for(seatKey in this.$store.state.theatre.rows[rowKey].seats){
          if(this.$store.state.theatre.rows[rowKey].seats[seatKey].status != 'available'){
            this.$store.state.theatre.rows[rowKey].seats[seatKey].status = 'available';
          }
        }
        if(index == Object.keys(this.$store.state.theatre.rows).length) this.$store.state.pageLoaded = true;
      }
    },

    openUpdateDialog(subscription){
      this.$store.state.dialogs.updateSubscription = true;
      this.$store.state.dialogs.subscriptionMain = true;
      this.$store.state.selectedObject = subscription;
      this.$store.dispatch('getTheatre', {url: this.$store.getters.getSeasonData.url});
    },

    closeDialogs(){
      this.$store.state.dialogs.subscriptionMain = false;
      this.$store.state.dialogs.updateSubscription = false;
      this.$store.state.dialogs.createSubscription = false;
    },

    createSubscription(){
      let context = {
        'season': this.$store.state.activeSeasonID,
        'subscription': this.$store.state.selectedObject.id,
        'rows': this.$store.state.theatre.rows,
        'seat_updates':{
          'status': 'unavailable',
          'seats': this.$store.getters.getSeatWithRow
        }
      }

      this.closeDialogs();
      this.$store.dispatch('createSubscription', {context});
    },

    deleteSubscription(){
      this.$store.dispatch('deleteSubscription', {subscription: this.$store.state.selectedObject});
    }
  }
}
</script>


<style lang="scss">
.subscriptions{
  padding-bottom: 40px;
  .export{
    display: none;
  }
}


.subscriptions-table{
  th{
    &:not(:first-of-type){
      .md-table-head-label{
        display: block;
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.theatre-dialog{
  width: 100%;
  min-height: 100vh;
  max-width: 100%;
  .theatre-seats{
    width: 100%;
    min-height: calc(100vh - 130px)
  }

  .md-toolbar.md-theme-default .md-title{
    color: rgba(0,0,0,0.87);
  }

  &.edit-subscription{
    .theatre-container{
      .theatre-seats{
        margin: 0 auto;
      }
    }
  }

  .theatre-container{
    margin-top: 30px;
    .theatre-seats{
      padding: 0;
      margin: 0;
      width: calc(100% - 400px);
    }

    .theatre-seats-holder{
      min-height: calc(100vh - 250px);
    }

    .selected-seats{
      position: absolute;
      top: 0;
      right: 0;
      width: 325px;
      .md-list{
        max-height: calc(100vh - 285px);
      }

      .md-card-actions .md-list-item{
        width: 100%;
      }
    }
  }
}

.edit-subscription-card{
  padding: 20px;
}

.edit-subscription-error{
  color: #ff5252;
  bottom: -30px !important;
  opacity: 1 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Admin/Subscriptions/Subscriptions.vue